// Password strength scoring — extracted verbatim from Register.js so it can be
// unit-tested and reused. Returns { score: 0-4, label, color }.
export function getPasswordStrength(password) {
  if (!password) return { score: 0, label: "", color: "" };
  let score = 0;
  if (password.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  return {
    score,
    label: ["", "Weak", "Fair", "Good", "Strong"][score],
    color: ["", "#ff4560", "#ffc542", "#00c8e8", "#00e87a"][score],
  };
}

export default getPasswordStrength;
